import { useState } from "react";

import { SuccessAlert } from "@/modules/alert";
import { Icon } from "@/modules/common/components/Icon";
import { useTranslation } from "@/modules/translations/useTranslation";

import { Host } from "./CopyToClipboard.styles";
import { copyToClipboard } from "./utils";

export { CopyToClipboard };

function CopyToClipboard({
  value = "",
  className,
}: {
  value?: string;
  className?: string;
}) {
  const { t } = useTranslation();
  const [showCopied, setShowCopied] = useState(false);

  const onCopy = async (e: any) => {
    e.stopPropagation();
    await copyToClipboard(value);
    setShowCopied(true);
  };

  return (
    <Host
      className={`${className} flex items-center justify-between`}
      onClick={onCopy}
    >
      {value}
      <Icon
        className="copy-to-clipboard__icon"
        name="copy"
        fontSize="small"
        onClick={onCopy}
      />
      {showCopied && (
        <SuccessAlert
          message={t("message.success.copied")}
          onClose={() => {
            setShowCopied(false);
          }}
        />
      )}
    </Host>
  );
}
